import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

const removeIgAccount = store => async (
    state,
    clientId,
    accountId,
    platformUserId,
) => {
    const userClientId = state.user.selectedUserClientId;

    const response = await sportsApi
        .url(`/clients/${clientId}/authorized-accounts/${accountId}`)
        .delete()
        .res();

    if (response.status != '204') {
        return;
    }

    store.setState(
        R.dissocPath(
            [
                'clients',
                userClientId,
                'socialAccounts',
                'instagram',
                'linkedAccounts',
                platformUserId,
            ],
            store.getState(),
        ),
        true,
    );
};

export default removeIgAccount;
